import { render, staticRenderFns } from "./aisearch.vue?vue&type=template&id=4b2b440f&scoped=true"
import script from "./aisearch.vue?vue&type=script&lang=js"
export * from "./aisearch.vue?vue&type=script&lang=js"
import style0 from "./aisearch.vue?vue&type=style&index=0&id=4b2b440f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2b440f",
  null
  
)

export default component.exports